import Tg from './ui/assets/telegram_logo.svg';
import Vk from './ui/assets/vk_logo.svg';
import Yt from './ui/assets/youtube_logo.svg';
import Ok from './ui/assets/ok_logo.svg';
import In from './ui/assets/instagram_logo.svg';
import Fb from './ui/assets/facebook_logo.svg';
import Tw from './ui/assets/twitter_logo.svg';
import Dz from './ui/assets/dzen_logo.svg';
import Tt from './ui/assets/tic-toc_logo.svg';
import { Socials } from './model/types';

export { SocialShare } from './ui/SocialShare';
export { Socials } from './model/types';
export type { ISocialLinks } from './model/types';
export const socialIcons = {
  [Socials.TG]: Tg,
  [Socials.VK]: Vk,
  [Socials.YT]: Yt,
  [Socials.OK]: Ok,
  [Socials.IN]: In,
  [Socials.FB]: Fb,
  [Socials.TW]: Tw,
  [Socials.DZ]: Dz,
  [Socials.TT]: Tt,
};
